import React from "react"
import { useCurrentDepartmentAccess } from "graphql/auth/auth.hooks"
import styles from "./map.module.scss"
export const Label = ({ src, text, style = undefined }) => {
  return (
    <div className={styles["legend"]}>
      <div>
        <img style={style} className="h-[15px]" src={src} alt={text}></img>
      </div>
      <div>{text}</div>
    </div>
  )
}
const TrackingMapLegends = () => {
  const isEcom = useCurrentDepartmentAccess()
  return (
    <section className="vt-tracking-map-legends">
      <Label
        src="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
        text={"Partial Rejected"}
      />
      <Label
        src="http://maps.google.com/mapfiles/ms/icons/green-dot.png"
        text={isEcom ? "Delivered" : "Harvested"}
      />
      <Label
        style={{
          marginLeft: 2,
        }}
        src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2_hdpi.png"
        text={isEcom ? "Rejected" : "Not Harvested"}
      />
      {isEcom && (
        <Label
          src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
          text="Not Delivered"
        />
      )}
      <Label
        src="https://cdn.vesatogo.com/images/business-and-trade_1.svg"
        text="Source"
      />
      <Label
        src="https://cdn.vesatogo.com/images/business-and-trade.svg"
        text="Destination"
      />
    </section>
  )
}

export default TrackingMapLegends
